/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StaticPageNestedServiceRequest
 */
export interface StaticPageNestedServiceRequest {
  /**
   *
   * @type {string}
   * @memberof StaticPageNestedServiceRequest
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof StaticPageNestedServiceRequest
   */
  price?: number | null
  /**
   * * `1` - Template 1
   * * `2` - Template 2
   * * `3` - Template 3
   * @type {number}
   * @memberof StaticPageNestedServiceRequest
   */
  currentTemplate: StaticPageNestedServiceRequestCurrentTemplateEnum
  /**
   *
   * @type {string}
   * @memberof StaticPageNestedServiceRequest
   */
  measureUnit?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageNestedServiceRequest
   */
  slug?: string | null
}

/**
 * @export
 */
export const StaticPageNestedServiceRequestCurrentTemplateEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const
export type StaticPageNestedServiceRequestCurrentTemplateEnum =
  (typeof StaticPageNestedServiceRequestCurrentTemplateEnum)[keyof typeof StaticPageNestedServiceRequestCurrentTemplateEnum]

/**
 * Check if a given object implements the StaticPageNestedServiceRequest interface.
 */
export function instanceOfStaticPageNestedServiceRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'currentTemplate' in value

  return isInstance
}

export function StaticPageNestedServiceRequestFromJSON(
  json: any,
): StaticPageNestedServiceRequest {
  return StaticPageNestedServiceRequestFromJSONTyped(json, false)
}

export function StaticPageNestedServiceRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StaticPageNestedServiceRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    price: !exists(json, 'price') ? undefined : json['price'],
    currentTemplate: json['currentTemplate'],
    measureUnit: !exists(json, 'measureUnit') ? undefined : json['measureUnit'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function StaticPageNestedServiceRequestToJSON(
  value?: StaticPageNestedServiceRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    price: value.price,
    currentTemplate: value.currentTemplate,
    measureUnit: value.measureUnit,
    slug: value.slug,
  }
}
